module.exports = __webpack_public_path__ + "img/end_finished.738df33f.svg";